import React from 'react';

export default function StatusBadge({ status, reason, size = 'medium' }) {
  const isSmall = size === 'small';

  const baseStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.4rem',
    borderRadius: '9999px',
    fontWeight: '600',
    fontSize: isSmall ? '0.75rem' : '0.875rem',
    padding: isSmall ? '0.2rem 0.6rem' : '0.35rem 0.85rem',
    textTransform: 'capitalize',
    letterSpacing: '0.025em'
  };

  if (status === 'accepted') {
    return (
      <span style={{ ...baseStyle, backgroundColor: '#dcfce7', color: '#166534', border: '1px solid #86efac' }}>
        <svg width="14" height="14" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
        </svg>
        Accepted
      </span>
    );
  }

  if (status === 'rejected') {
    return (
      <div style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-start', gap: '0.25rem' }}>
        <span style={{ ...baseStyle, backgroundColor: '#fee2e2', color: '#991b1b', border: '1px solid #fca5a5' }}>
          <svg width="14" height="14" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
          Retake Required
        </span>
        {reason && (
          <span style={{ fontSize: '0.8rem', color: '#dc2626', maxWidth: '280px', lineHeight: 1.3 }}>
            {reason}
          </span>
        )}
      </div>
    );
  }

  if (status === 'under_review') {
    return (
      <span style={{ ...baseStyle, backgroundColor: '#fef3c7', color: '#92400e', border: '1px solid #fcd34d' }}>
        <svg width="14" height="14" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
        </svg>
        Under Review
      </span>
    );
  }

  return (
    <span style={{ ...baseStyle, backgroundColor: '#f3f4f6', color: '#4b5563', border: '1px solid #e5e7eb' }}>
      <svg className="animate-spin" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <circle cx="12" cy="12" r="10" strokeWidth="4" stroke="currentColor" strokeDasharray="30 60" />
      </svg>
      Processing
    </span>
  );
}

